
import { Component, Vue } from "vue-property-decorator";

@Component({})
/** Plain white shadowed card wrapper, no logic — content via default slot. */
export default class Card extends Vue {}
